<template>
  <div class="message-container">
    <ul id="message-container-list" class="message-container__list">
      <MessageListItem v-for="message in messageList" :key="message.id" :message="message" />
      <NoData
        class="message-container__list__no-data"
        text="暂无消息"
        v-if="!messageList || messageList.length === 0"
      />
    </ul>
    <Pagination
      v-if="messageList.length > 0"
      @changePage="changePage"
      :pageSize="pageSize"
      :totalCount="totalCount"
    />
  </div>
</template>

<script>
import MessageListItem from './components/messageListItem'
import Pagination from '@/components/Pagination'
import NoData from '@/components/noData'
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    MessageListItem,
    Pagination,
    NoData
  },
  data() {
    return {
      pageSize: 10
    }
  },
  mounted() {
    this.changePage(1)
  },
  computed: {
    ...mapState('message', {
      messageList: state => state.messageList,
      totalCount: state => state.totalCount
    })
  },
  methods: {
    changePage(pageNo) {
      const loading = this.$loading({ target: '#message-container-list', fullscreen: false })
      this.getMessageList({ pageNo, pageSize: this.pageSize }).then(res => {
        loading.close()
      })
    },
    ...mapActions('message', ['getMessageList'])
  }
}
</script>

<style lang="scss" scoped>
.message-container {
  margin-top: 30px;
  font-size: 14px;

  &__list {
    height: 400px;
    padding: 0;
    padding-right: 12px;

    &__no-data {
      margin-top: 75px;
      margin-bottom: 20px;
    }
  }
}
</style>
